import cn from 'classnames'
import { memo, type ReactElement } from 'react'
import { PlaceholderBox } from '../../../../../../shared/components/ui/PlaceholderBox'

interface SalesCardProps {
  additionalClasses?: string
  loading: boolean
  title: string
  secondaryTitle?: string
  amount: string
  secondaryAmount?: string
}

function SalesCard ({ additionalClasses, loading, title, secondaryTitle, amount, secondaryAmount }: SalesCardProps): ReactElement {
  return (
    <div className={cn('w-1/2 bg-white rounded shadow-lg p-4 md:mr-4', additionalClasses)}>
      <PlaceholderBox loading={loading}>
        <div className="flex flex-row justify-between">
          <h4 className="text-gray-600 font-semibold">{title}</h4>
          <h4 className="text-gray-600 font-semibold">{secondaryTitle}</h4>
        </div>
        <hr className="my-2" />
        <div className="flex justify-between">
          <div className="font-bold text-xl">{amount}</div>
          <div className="font-bold text-xl">{secondaryAmount}</div>
        </div>
      </PlaceholderBox>
    </div>

  )
}

export default memo(SalesCard)
